import { useFlags } from 'launchdarkly-react-client-sdk';
import { Navigate, Outlet } from 'react-router-dom';

import type { LdFeatureFlags } from '@/config/features';
import LoadingPage from '@/pages/loading';

type BooleanFlagKey = {
  [K in keyof LdFeatureFlags]: LdFeatureFlags[K] extends boolean ? K : never;
}[keyof LdFeatureFlags];

type JsonFlagKey = Exclude<keyof LdFeatureFlags, BooleanFlagKey>;

type FlagGuardProps<Key extends JsonFlagKey> = { isLdIdentityReady: boolean } & (
  | { flag: BooleanFlagKey; isEnabled?: undefined }
  | { flag: Key; isEnabled: (value: LdFeatureFlags[Key]) => boolean }
);

const FlagGuard = <Key extends JsonFlagKey>({ flag, isEnabled, isLdIdentityReady }: FlagGuardProps<Key>) => {
  const flags = useFlags<LdFeatureFlags>();

  if (!isLdIdentityReady) return <LoadingPage />;

  if (!(isEnabled ? isEnabled(flags[flag]) : flags[flag])) return <Navigate to="/404" replace />;

  return <Outlet />;
};
FlagGuard.displayName = 'FlagGuard';

export default FlagGuard;
